import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import HomeSlider from '../../entities/booking/homeSlider';

interface HomeSliderState extends ListState<HomeSlider>{
    editHomeSlider:HomeSlider
}
class HomeSliderMutations extends ListMutations<HomeSlider>{

}
class HomeSliderModule extends ListModule<HomeSliderState,any,HomeSlider>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<HomeSlider>(),
        loading:false,
        editHomeSlider:new HomeSlider()
    }
    actions={
        async getAll(context:ActionContext<HomeSliderState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/HomeSlider/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<HomeSlider>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<HomeSliderState,any>,payload:any){
            await Ajax.post('/api/services/app/HomeSlider/Create',payload.data);
        },
        async update(context:ActionContext<HomeSliderState,any>,payload:any){
            await Ajax.put('/api/services/app/HomeSlider/Update',payload.data);
        },
        async delete(context:ActionContext<HomeSliderState,any>,payload:any){
            await Ajax.delete('/api/services/app/HomeSlider/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<HomeSliderState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/HomeSlider/Get?Id='+payload.id);
            return reponse.data.result as HomeSlider;
        }
    };
    mutations={
        setCurrentPage(state:HomeSliderState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:HomeSliderState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:HomeSliderState,homeSlider:HomeSlider){
            state.editHomeSlider=homeSlider;
        }
    }
}
const homeSliderModule=new HomeSliderModule();
export default homeSliderModule;